import { isString } from 'lodash';

import { MediaConfigType } from '@/const/richMedia';
import { eventPool } from '@/event/eventPool';
import { RichMediaValue } from '@/interface/media';

import { IFileInfo } from './image';

export const getMediaUrlValue = (data?: string | RichMediaValue) => {
  const value: {
    media: any;
    url?: string | { url?: string };
    localPath?: string | undefined;
    name?: string | undefined;
  } = transRichMediaValue(data);
  return (isString(value.url) ? value.url : value.url?.url) || '';
};

export const transRichMediaValue = (
  value?: string | RichMediaValue,
  defaultValue: any = { url: '' },
) => {
  if (!value) {
    return { media: defaultValue };
  }
  if (isString(value)) {
    return { media: defaultValue, url: value };
  }
  const { id, url, sample, fillType, ...media } = value;
  return {
    id,
    ...url,
    sample,
    fillType,
    media: { ...defaultValue, ...media },
  };
};

export const emitRichMediaPIC = (url: string) => {
  const localPath = getRichLocalPath(url);
  emitRichMedia(localPath, url, MediaConfigType.PIC);
};

export const emitRichMediaFile = (url: string) => {
  const localPath = getRichLocalPath(url);
  emitRichMedia(localPath, url, MediaConfigType.File);
};

export const emitRichMedia = (
  localPath: string,
  url: string,
  type: MediaConfigType,
) => {
  eventPool.eventsEmit.materialChange({
    key: localPath,
    url,
    type: type || MediaConfigType.PIC,
  });
};

export const emitRichFilterMedia = (params: {
  [key: string]: RichMediaValue | undefined;
}) => {
  eventPool.eventsEmit.materialFilterImage(params);
};

export const richValueChange = (params?: RichMediaValue) => {
  if (params) {
    const localPath = getRichLocalPath(params?.url?.url);
    return {
      ...params,
      url: {
        ...params?.url,
        localPath,
      },
    };
  }
  return params;
};

export const transFileInfo = (params?: IFileInfo) => {
  const { url, name } = params || {};
  const localPath = getRichLocalPath(url);
  return {
    ...params,
    name,
    localPath,
    url: {
      url,
      name,
      localPath,
    },
  };
};

export const getRichLocalPath = (url?: string) => {
  if (url) {
    const localPath = url?.split('/')?.pop();
    return localPath || '';
  }
  return '';
};
